// Descriptors profile
export const JSON_PROFILE = require('../descriptors/netco_employee.json');
